import { Injectable } from '@angular/core'
import { createFrom, EventService, WindowRef } from '@spartacus/core'
import { MouseFlowEvent } from './mouse-flow.event'
import { NavigationEvent } from '@spartacus/storefront'
import { distinctUntilChanged, map } from 'rxjs/operators'
import { WindowObject } from '@spartacus/tracking/tms/core'

@Injectable({
  providedIn: 'root'
})
export class MbMouseFlowEventBuilder {

  constructor (protected eventService: EventService,
              protected windowRef: WindowRef) {
    this.init()
  }

  get mouseFlow () {
    return (this.windowRef.nativeWindow as WindowObject | undefined)?.['mouseflow']
  }

  init () {
    this.eventService.register(MouseFlowEvent, this.buildMouseFlowEvent())
  }

  buildMouseFlowEvent () {
    return this.eventService.get(NavigationEvent).pipe(
      distinctUntilChanged((p, c) => (p.url.replace(/\?.*/g, '$\'') === c.url.replace(/\?.*/g, '$\'')) ||
        p.url.replace(/#.*/g, '$\'') === c.url.replace(/#.*/g, '$\'')),
      map(navigation => createFrom(MouseFlowEvent, {
        navigation,
        mouseFlow: this.mouseFlow
      }))
    )
  }
}
